export default function getAgeGroupsURL(customerIds?: number): string {
  return `/api/utility/ageGroups${
    customerIds ? `?customerIds=${customerIds}&ageGroupType=real` : ''
  }`;
}
